import { Outlet, useLocation } from "react-router-dom";
import { Header } from "../component/Header";
import { Footer } from "../component/Footer";
import Hamburger from "../component/hamburger";
import { useEffect, useState } from "react";
import { MobileFloatingBtn } from "../component/MobileFloatingBtn";
import { useResponsiveMobile } from "../hooks/useResponsiveMobile";

export default function WithHeaderLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const isApplication = pathname.startsWith("/inquiry-form");

  const FLOATING_BTN_SPACE = "pb-[96px]";

  const [onHamburger, setOnHamburger] = useState(false);

  const isMobile = useResponsiveMobile(900);

  useEffect(() => {
    setOnHamburger(false);
  }, [pathname]);

  useEffect(() => {
    if (!isMobile) setOnHamburger(false);
  }, [isMobile]);

  const headerClass =
    isHome || isApplication
      ? `${isHome ? "fixed" : "absolute"} top-0 left-0 z-20 w-full`
      : "fixed w-full bg-white z-[999] border-b-[#DDE0E6] border-b-[1px]";

  //  조건을 “원하는 정책 그대로” 분리
  const showHamburger = isMobile; // 모바일 전 페이지
  const showMobileFloating = isMobile && !isApplication; // 모바일 + application 제외
  const mainPaddingClass = showMobileFloating ? FLOATING_BTN_SPACE : ""; // 버튼 있을 때만

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        className={headerClass}
        onClickHamburger={() => {
          if (isMobile) setOnHamburger(true);
        }}
      />

      {/*  Hamburger: 모바일 전 페이지 공통 */}
      {showHamburger && <Hamburger open={onHamburger} onClose={() => setOnHamburger(false)} />}

      {/*  MobileFloatingBtn: 모바일 + /application 제외 */}
      {showMobileFloating && <MobileFloatingBtn />}

      {isHome ? (
        <>
          <main className={`flex flex-col flex-1 ${mainPaddingClass}`}>
            <div className="flex-1">
              <Outlet />
            </div>
            <Footer />
          </main>
        </>
      ) : isApplication ? (
        <>
          <main className={`flex flex-col flex-1 ${mainPaddingClass}`}>
            <div className="flex-1 flex">
              <Outlet />
            </div>
            <Footer />
          </main>
        </>
      ) : (
        <>
          <main className={`flex flex-col flex-1 pt-[80px] md:pt-[100px] ${mainPaddingClass}`}>
            <div className="flex-1 flex">
              <Outlet />
            </div>
            <Footer />
          </main>
        </>
      )}
    </div>
  );
}
